import { useEffect, useRef } from 'react';
import * as echarts from 'echarts';
import { EChartOption } from 'echarts';
import { chartsTheme } from './ChartsTheme';
import { ChartProps } from '../../services/Models/ICharts';

export const Line = (props: ChartProps) => {
    const chartRef = useRef<HTMLDivElement>(null);
    const chartInstanceRef = useRef<echarts.EChartsType | null>(null);

    useEffect(() => {
        // Register the custom theme
        echarts.registerTheme('chartsTheme', chartsTheme.theme);

        // Initialize chart
        if (chartRef.current) {
            chartInstanceRef.current = echarts.init(chartRef.current, 'chartsTheme');
        }

        // Chart options
        const options: EChartOption = {
            title: {
                text: props.title,
                left: 'center',
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow',
                },
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true,
            },
            xAxis: [
                {
                    type: 'category',
                    data: props.data.map(item => item.name),
                    axisTick: {
                        alignWithLabel: true,
                    },
                },
            ],
            yAxis: [
                {
                    type: 'value',
                },
            ],
            series: props.data
        };

        // Set options
        chartInstanceRef.current?.setOption(options);

        // Handle resize
        const handleResize = () => {
            chartInstanceRef.current?.resize();
        };
        window.addEventListener('resize', handleResize);

        // Cleanup
        return () => {
            chartInstanceRef.current?.dispose();
            chartInstanceRef.current = null;
            window.removeEventListener('resize', handleResize);
        };
    }, [props.data, props.title]);


    return <div className="rounded-lg shadow-lg" ref={chartRef} style={{ width: `${props.width}px`, height: `${props.height}px` }} />;
};

